import axios from "axios";

// Base API URL - adjust according to your backend configuration
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000/api";

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  // headers: {
  // 'Content-Type': 'application/json',
  // },
  withCredentials: true, // CRITICAL: Send httpOnly cookies with requests
});

// Request interceptor - backend reads token from httpOnly cookie
axiosInstance.interceptors.request.use(
  (config) => {
    // No need to manually add Authorization header
    // Backend will read JWT token from httpOnly cookie
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle common errors
axiosInstance.interceptors.response.use(
  (response) => {
    // Return the response data directly
    return response;
  },
  (error) => {
    // Handle common errors
    if (error.response) {
      // Server responded with error status
      const { status } = error.response;

      if (status === 401) {
        // Unauthorized - clear session and redirect to login
        sessionStorage.clear();

        // Prevent infinite redirect loop
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }

      if (status === 403) {
        console.error("Access forbidden");
      }

      if (status >= 500) {
        console.error("Server error occurred");
      }
    } else if (error.request) {
      // Request made but no response received
      console.error("No response from server");
    } else {
      // Something else happened
      console.error("Error:", error.message);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
